import { useState, useEffect } from "react";
import { SACRED_FALLBACK_IMAGE } from "@/lib/sacred-library/utils/image-urls";

/**
 * Small circular icon for library lists and search.
 */
export function SacredIcon({ src, alt, className = "w-10 h-10 flex-shrink-0", testId }) {
  const [url, setUrl] = useState(src || SACRED_FALLBACK_IMAGE);

  useEffect(() => {
    setUrl(src || SACRED_FALLBACK_IMAGE);
  }, [src]);

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full overflow-hidden bg-muted/40 ring-1 ring-border/50 ${className}`}
      data-testid={testId}
    >
      <img
        src={url}
        alt={alt || ""}
        className="w-full h-full object-contain p-0.5"
        loading="lazy"
        decoding="async"
        onError={() => {
          if (url !== SACRED_FALLBACK_IMAGE) setUrl(SACRED_FALLBACK_IMAGE);
        }}
      />
    </span>
  );
}
